import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const GustoWidgetSkeleton = () => (
  <div className='box-border bg-bw00 w-full h-full rounded-[12px] flex justify-between items-start p-[24px] flex-col'>
    <SkeletonTheme baseColor='#DFE2EB'>
      <div className='w-full flex justify-between'>
        <div>
          <Skeleton width='156px' height='11px' borderRadius='13px' count={1} containerClassName='h-[11px] leading-3' />
        </div>
        <div className='flex'>
          <Skeleton width='60px' height='60px' borderRadius='8px' count={1} containerClassName='h-[60px] leading-3' />
        </div>
      </div>
      <div className='flex flex-col mt-[10px] w-full'>
        <div className='flex justify-between w-full'>
          <Skeleton width='156px' height='11px' borderRadius='13px' count={2} containerClassName='h-[11px] leading-3' />
        </div>
        <div className='flex justify-between w-full mt-[50px]'>
          <Skeleton width='156px' height='11px' borderRadius='13px' count={2} containerClassName='h-[11px] leading-3' />
        </div>
      </div>
      <div className='flex justify-end w-full'>
        <Skeleton width='156px' height='11px' borderRadius='13px' count={1} containerClassName='h-[11px] leading-3' />
      </div>
    </SkeletonTheme>
  </div>
);
